import produce from 'immer';

import {
  CONNECT_SUCCESS 
} from 'constants/actions';

export var INITIAL_STATE = {
  updated: null
};

export const error = produce((draft, action) => {
  switch (action.type) {
    case CONNECT_SUCCESS:
      return { ...draft, updated: action.value };

    default:
      return draft;
  }
}, INITIAL_STATE);

export default error;
